import {createAction} from 'redux-actions';
import * as Constants from './constants';

export const getListAgencyAction = createAction(Constants.GET_LIST_AGENCY.REQUEST, (filters) => (filters));
